import React from 'react';

import { v4 as uuid } from 'uuid';

import { CloseButton } from 'commons/components/Button';
import { ConditionalRender } from 'commons/components/ConditionalRender';
import { LIGHT_GRAY, PRIMARY_RED } from 'commons/styles/colors';

import { AddedCriteriaProps, Criteria } from '../SearchWithCriteria.interface';

import { S } from './AddedCriteria.styles';

export const AddedCriteria: React.FC<AddedCriteriaProps> = ({
  criterias,
  onRemoveCriteria,
}) => {
  const handleRemoveCriteria = (criteria: Criteria): void => {
    onRemoveCriteria(criteria);
  };

  const isIncludeCriteria = (criteria: Criteria): boolean => {
    return !criteria.name.includes(' not ');
  };

  return (
    <>
      {criterias.map((criteria: Criteria) => (
        <S.CriteriaContainer key={uuid()}>
          <span>
            {criteria.name}&nbsp;
            <ConditionalRender condition={isIncludeCriteria(criteria)}>
              has&nbsp;
            </ConditionalRender>
          </span>
          <strong className="criteria-value">{criteria.value}</strong>
          <CloseButton
            onClick={(): void => handleRemoveCriteria(criteria)}
            onKeyDown={(): void => handleRemoveCriteria(criteria)}
            color={PRIMARY_RED}
            backgroundColor={LIGHT_GRAY}
          />
        </S.CriteriaContainer>
      ))}
    </>
  );
};
